/**
 * @fileoverview Provides the `batch` function, which splits an array into smaller arrays (batches) of a specified `batchSize`. The function returns a `T[][]` where `T` is the type of the input array elements.
 */


export function batch<T>(arr: T[], batchSize: number): T[][] {
  return arr.reduce((acc, s) => {
    if (acc.length === 0 || acc[acc.length - 1]!.length >= batchSize) {
      return [...acc, [s]]
    }
    return [...acc.slice(0, -1), [...acc[acc.length - 1]!, s]]
  }, [] as T[][])
}
